import { CheckoutProvider } from '@app/store/CheckoutContext'
import { Spinner } from '@grupoboticario/flora-react-spinner'
import { createBrowserHistory } from 'history'
import React, { lazy, Suspense } from 'react'
import { Route, Router, Switch } from 'react-router'

import Home from '@/view/home/Home'
const Checkout = lazy(() => import('@/view/checkout/Checkout'))
const CheckoutSuccess = lazy(() => import('@/view/checkout/CheckoutSuccess'))
const CheckoutExpired = lazy(() => import('@/view/checkout/CheckoutExpired'))
const CheckoutCanceled = lazy(() => import('@/view/checkout/CheckoutCanceled'))

const history = createBrowserHistory()

const Routes = () => {
  return (
    <CheckoutProvider>
      <Router history={history}>
        <Suspense fallback={<Spinner />}>
          <Switch>
            <Route path="/" exact component={Home}></Route>
            <Route path="/:id" exact component={Checkout}></Route>
            <Route
              path="/:id/success"
              exact
              component={CheckoutSuccess}
            ></Route>
            <Route
              path="/:id/expired"
              exact
              component={CheckoutExpired}
            ></Route>
            <Route
              path="/:id/canceled"
              exact
              component={CheckoutCanceled}
            ></Route>
          </Switch>
        </Suspense>
      </Router>
    </CheckoutProvider>
  )
}

export default Routes
